<template>
	<div class="facebookText">
		<skyTextarea :value="value" @input="input" :disabled="disabled"></skyTextarea>
		<div class="tip">话题格式为：#话题内容，话题前后需用空格与文本隔开</div>
		<div class="assets">
			<emoji
				@select="emojiSelect"
				v-model="emojiVisible"
				class="emoji item"
				:disabled="disabled"
			></emoji>
			<div :class="isImg ? 'item' : 'item noUpload'">
				<facebookUpload
					accept="image/jpeg, image/png, image/gif"
					@upload="upload"
					:list="list"
					type="image"
					:disabled="!isImg"
					v-bind="$attrs"
				>
					<el-tooltip
						class="item"
						effect="dark"
						content="由于Facebook平台的安全风控限制，当前暂时无法发布包含图片或视频的帖子。"
						placement="top-start"
						:disabled="!isFacebookLimit"
					>
						<img class="item_img_one" src="~@/assets/richText/tupian.png" />
					</el-tooltip>
				</facebookUpload>
			</div>
			<div :class="isVideo ? 'item' : 'item noUpload'">
				<facebookUpload
					accept="video/*"
					@upload="upload"
					:list="list"
					type="video"
					:disabled="!isVideo"
					v-bind="$attrs"
				>
					<el-tooltip
						class="item"
						effect="dark"
						content="由于Facebook平台的安全风控限制，当前暂时无法发布包含图片或视频的帖子。"
						placement="top-start"
						:disabled="!isFacebookLimit"
					>
						<img class="item_img_two" src="~@/assets/richText/shipin.png" />
					</el-tooltip>
				</facebookUpload>
			</div>
		</div>
	</div>
</template>

<script>
import skyTextarea from '@/components/iglobalwin/formComponents/sky-textarea.vue';
import emoji from '@/components/chat/components/emoji.vue';
import fileUpload from '@/components/chat/components/fileUpload.vue';
import facebookUpload from './facebookUpload.vue';

export default {
	name: 'facebookText',
	props: ['value', 'focus', 'fileChange', 'list', 'disabled', 'isFacebookLimit'], // isFacebookLimit  Facebook 平台的安全风控限制
	components: {
		skyTextarea,
		emoji,
		fileUpload,
		facebookUpload,
	},
	data() {
		return {
			emojiVisible: false,
		};
	},
	computed: {
		isImg: self => {
			let { list, disabled, isFacebookLimit } = self;
			if (isFacebookLimit) return false;
			if (disabled) return false;
			if (list.length > 0 && list[0].type == 'video') return false;
			return true;
		},
		isVideo: self => {
			let { list, disabled, isFacebookLimit } = self;
			if (isFacebookLimit) return false;
			if (disabled) return false;
			if (list.length > 0 && list[0].type == 'image') return false;
			if (list.length == 1) return false;
			return true;
		},
	},
	methods: {
		// 输入框输入
		input(e) {
			this.$emit('input', e);
		},
		// 表情选择
		emojiSelect(val) {
			this.emojiVisible = false;
			this.$emit('input', this.value + val);
		},
		// 本地文件选择
		upload(list) {
			this.fileChange(list);
		},
	},
};
</script>

<style lang="scss" scoped>
.facebookText {
	::v-deep .emoji {
		cursor: pointer;

		.el-popover__reference {
			margin-left: 0px !important;
			width: 21px;
			height: 21px;
		}
	}

	.tip {
		font-size: 13px;
		color: #e6a23c;
	}

	.assets {
		margin-top: 5px;
		display: flex;

		.item {
			display: flex;
			line-height: normal;
			margin: 0 2px;
			height: 22px;

			img {
				width: 20px;
				height: 21px;
			}

			.item_img_one {
				width: 21px;
				height: 22px;
			}
		}

		.noUpload {
			::v-deep .el-upload {
				cursor: not-allowed !important;
			}
		}
	}
}
</style>
